module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-5__b0b6375d8ae0bc0545794df96339fd8a.png";